<script setup lang="ts">
import { useRoute } from 'vue-router'
import SlicesDirectoryList from './SlicesDirectoryList.vue'

const route = useRoute()
</script>

<template>
  <div class="bg-white w-[280px] overflow-y-scroll h-screen text-gray-500 text-xs py-4">
    <div>
      <ul class="space-y-6">
        <li>
          <div
            class="px-4 mb-4 w-full flex justify-between items-center text-2xs tracking-wider font-semibold uppercase text-gray-400 border-b border-gray-300 pb-1"
            :class="{
              'voix-admin-text': route.name === 'templatizer-slices-en',
            }"
          >
            Slices
          </div>
          <SlicesDirectoryList
            v-if="route.name === 'templatizer-slices-en'"
            class="sticky inset-0"
          />
        </li>
      </ul>
    </div>

    <button
      class="lg:hidden fixed z-30 bottom-0 left-0 m-4 rounded-full border p-4 bg-white border-slate-200"
    >
      <svg
        class="w-6 h-6"
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
          clip-rule="evenodd"
        />
      </svg>
    </button>
  </div>
</template>
